import React from 'react';
import LandingPage from '../components/LandingPage';

function Home() {
  return (
    <div className="home-page">
      <LandingPage />
    </div>
  );
}

export default Home;
